<template>
    <div class="dataCenter">
        <iframe :src="url" frameborder="0"></iframe>
    </div>
</template>

<script>
import common from "@common/common";
import { apis } from "@common/config";

export default {
    data() {
        return {
            url: ''
        }
    },
    methods: {
        getDataCenter() {
            if(this.$route.query.type){
                let info = {
                    type: this.$route.query.type
                }
                common
                .myFetch(apis.getDataInfo, info)
                .then(r => {
                    if (r) {
                        console.log(r)
                        this.url = r.host
                    }
                });
            }
        }
    },
    mounted() {
        this.getDataCenter()
    }
}
</script>

<style lang="less" scoped>
    .dataCenter {
        width: 100vw;
        height: calc(100vh - 70px);
        overflow: hidden;

        iframe {
            width: 100%;
            height: 100%;
        }
    }
</style>